import { useEffect } from 'react';
import { analytics } from '../utils/analytics';

export const useAnalytics = () => {
  useEffect(() => {
    // Initialize analytics with tracking ID from environment
    const trackingId = import.meta.env.VITE_GA_TRACKING_ID;
    const debug = import.meta.env.DEV;

    if (trackingId) {
      analytics.initialize(trackingId, debug);
    }
  }, []);

  return analytics;
};

export default useAnalytics;
